import { render, staticRenderFns } from "./ship.vue?vue&type=template&id=3268e37c"
import script from "./ship.vue?vue&type=script&lang=js"
export * from "./ship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3268e37c')) {
      api.createRecord('3268e37c', component.options)
    } else {
      api.reload('3268e37c', component.options)
    }
    module.hot.accept("./ship.vue?vue&type=template&id=3268e37c", function () {
      api.rerender('3268e37c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/ship/ship.vue"
export default component.exports